module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNisAcAAEgAQt9UfOgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/style/overlay.png
// module id = 31
// module chunks = 0